import React, { createContext, useContext, useState, ReactNode, useCallback } from 'react';

interface VendorProfileContextType {
  profileImageUrl: string | null;
  updateProfileImage: (newImageUrl: string) => void;
}

const VendorProfileContext = createContext<VendorProfileContextType | undefined>(undefined);

interface VendorProfileProviderProps {
  children: ReactNode;
}

export const VendorProfileProvider: React.FC<VendorProfileProviderProps> = ({ children }) => {
  const [profileImageUrl, setProfileImageUrl] = useState<string | null>(null);

  const updateProfileImage = useCallback((newImageUrl: string) => {
    // Add cache-busting timestamp
    const cacheBustedUrl = `${newImageUrl}?t=${Date.now()}`;
    setProfileImageUrl(cacheBustedUrl);
  }, []);

  const value: VendorProfileContextType = {
    profileImageUrl,
    updateProfileImage,
  };

  return (
    <VendorProfileContext.Provider value={value}>
      {children}
    </VendorProfileContext.Provider>
  );
};

export const useVendorProfile = (): VendorProfileContextType => {
  const context = useContext(VendorProfileContext);
  if (context === undefined) {
    throw new Error('useVendorProfile must be used within a VendorProfileProvider');
  }
  return context;
};
